export default __webpack_public_path__ + "static/media/pd1.da95af15.jpg";